import { Trans } from "react-i18next";import { Info } from "lucide-react";
import { ui } from "../../../components/ui";
import { computeGrossDurationHours, isOvernightShift } from "../utils/shiftTimeUtils";

const fieldLabelClass = "block text-xs font-semibold per-file-hint mb-1.5";

export function ShiftTimingFields({ formState, setFormState, fieldErrors, validateField }) {
  const isOvernight = isOvernightShift(formState.shiftStartTime, formState.shiftEndTime);
  const grossDuration = computeGrossDurationHours(formState.shiftStartTime, formState.shiftEndTime);

  const handleChange = (field) => (e) => {
    const value = e.target.value;

    // First update the core state atomically
    setFormState((p) => ({ ...p, [field]: value }));

    // Compute next state snapshot directly to trigger clean sequential validations safely
    const updatedState = { ...formState, [field]: value };
    validateField(field, value, updatedState);

    // End time's zero-length check depends on start time, so re-validate both
    if (field === "shiftStartTime" && updatedState.shiftEndTime) {
      validateField("shiftEndTime", updatedState.shiftEndTime, updatedState);
    }
  };

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      <label className="flex flex-col gap-1.5">
        <span className={fieldLabelClass}>
          <Trans i18nKey="dateTime.shiftStartTime" /> <span className="text-error">*</span>
        </span>
        <input
          type="time"
          className={`${ui.input} w-full ${
          fieldErrors.shiftStartTime ? "border-error focus:border-error" : ""}`
          }
          value={formState.shiftStartTime}
          onChange={handleChange("shiftStartTime")} />
        
        {fieldErrors.shiftStartTime &&
        <p className="text-[11px] text-error mt-1">{fieldErrors.shiftStartTime}</p>
        }
      </label>

      <label className="flex flex-col gap-1.5">
        <span className={fieldLabelClass}>
          <Trans i18nKey="dateTime.shiftEndTime" /> <span className="text-error">*</span>
        </span>
        <input
          type="time"
          className={`${ui.input} w-full ${
          fieldErrors.shiftEndTime ? "border-error focus:border-error" : ""}`
          }
          value={formState.shiftEndTime}
          onChange={handleChange("shiftEndTime")} />
        
        {fieldErrors.shiftEndTime &&
        <p className="text-[11px] text-error mt-1">{fieldErrors.shiftEndTime}</p>
        }
      </label>

      {isOvernight && !fieldErrors.shiftEndTime &&
      <div className="md:col-span-2 flex items-start gap-2 rounded-xl border border-accent/25 bg-accent/5 px-3.5 py-2.5 text-[13px] text-foreground">
          <Info className="h-4 w-4 shrink-0 mt-0.5 text-accent" />
          <span>
            <Trans i18nKey="dateTime.thisShiftEndsTheNextDayGrossDuration" />
            {grossDuration !== null ? ` = ${grossDuration}h.` : "."}
          </span>
        </div>
      }

      {!isOvernight && grossDuration !== null && !fieldErrors.shiftEndTime &&
      <div className="md:col-span-2 text-[12px] per-file-hint px-1">
          <Trans i18nKey="dateTime.grossShiftDuration" /> <span className="font-semibold text-foreground">{grossDuration}<Trans i18nKey="uom.h" /></span>
        </div>
      }
    </div>);

}
